import Axios from "axios"

let subDom = localStorage.getItem("subDomain");

const instance = Axios.create({
  baseURL: `https://${subDom}/api`,
  withUniversalLoader: false
})

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if(token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
  },
  (error) => { return Promise.reject(error);}
)

instance.interceptors.response.use((res) => {
  return res;
  },
  async (error) => {
    const originalConfig = error.config;
    if(error.response) {
      if((error.response.status === 403 || error.response.status === 401) && !originalConfig._retry) {
        originalConfig._retry = true;
        const refreshToken = localStorage.getItem("refresh");

        // For Preventing Infinite Loop of Refresh Token api
        if((error.response.status !== 200 && error.response.config.url === "/token/refresh/") || refreshToken?.length === 0) {
          localStorage.clear();
          window.location.reload();
        }

        let data = "";
        const parts = refreshToken?.split(".");
        try {
          const decodedData = atob(parts?.[1]);
          data = JSON.parse(decodedData);
        } catch (error) {
          console.error("Error parsing JSON:", error);
        }

        const time = Math.floor(new Date().getTime() / 1000);
        if(data?.exp < time || error?.response?.data?.data?.error === 'InvalidToken' || error?.response?.data?.data?.error === 'Token is invalid or expired.') {
          try {
            const rs = await instance.post("/token/refresh/", {
              refresh: localStorage.getItem("refresh")
            });
            const token = rs?.data?.data?.access
            localStorage.setItem("token",token);

            return instance(originalConfig);
          } catch (_error) {
            return Promise.reject(_error);
          }
        } else {
          localStorage.clear();
          window.location.reload()
        }
      }
      return Promise.reject(error.response);
    }else{
      return Promise.reject(error)
    }
  }
)

export default instance;